import React from "react";

export default function PreviousItems({ showPreviousItems, scrollIndicatorHeightClass }) {

  return (
    <div className={`d-none d-sm-block previous-items-container ${scrollIndicatorHeightClass}`} onClick={showPreviousItems}>
      <span className="fas fa-chevron-left previous-items" />
    </div>
  );
}